import api from './Api'

const route = '/auth/roles'

export default {
  get: params => api().get(`${route}`, { params })
}
